import { render, staticRenderFns } from "./CorrelationMatrixSquare.vue?vue&type=template&id=4ed096fc&scoped=true&"
import script from "./CorrelationMatrixSquare.vue?vue&type=script&lang=js&"
export * from "./CorrelationMatrixSquare.vue?vue&type=script&lang=js&"
import style0 from "./CorrelationMatrixSquare.vue?vue&type=style&index=0&id=4ed096fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed096fc",
  null
  
)

export default component.exports